<div class="order-list">
  <mat-selection-list #selectedOrderIds [disableRipple]="true" class="overflow-y-auto flex-1 bg-white">
    <div class="flex pb-1 pl-2 pr-2 items-center">
      <div class="flex-1">Group By Destination</div>
      <div>
        <mat-slide-toggle
          class="flex-1"
          color="primary"
          #groupByToggle
          [checked]="byDestinationView$ | async"
          (click)="toggleGroupByDestination($event, !groupByToggle.checked)"
          labelPosition="before"
        >
        </mat-slide-toggle>
      </div>
    </div>
    <ng-container *ngFor="let groupedOrders of inProgressOrders$ | async; trackBy: trackByIdFn">
      <div *ngIf="groupedOrders.orders.length" class="group-header">
        <mat-checkbox
          (change)="
            toggleOrderGroupChecks($event, conditionalValueByGroup(groupedOrders.id, groupedOrders.inProgressStatus))
          "
          *saAllowedAccountRoles="[1, 2, 9, 10]"
          saAutomatedSelector="lmo_orders_pending__mesh_checkbox"
          >{{ conditionalValueByGroup(groupedOrders.type, groupedOrders.inProgressStatus) }}
          {{ conditionalValueByGroup('Mesh', null) }}
        </mat-checkbox>
        <span>{{ groupedOrders.orders.length | i18nPlural: loadPluralMapping }}</span>
      </div>
      <div *ngFor="let order of groupedOrders.orders; trackBy: trackByIdFn" class="flex border-b border-gray-400">
        <div class="flex w-6 items-center">
          <mat-list-option
            checkboxPosition="before"
            [value]="order"
            *saAllowedAccountRoles="[1, 2, 9, 10]"
          ></mat-list-option>
        </div>
        <a class="order-item flex-1" [routerLink]="['../', order.id]">
          <div class="header">
            <div class="load-number">
              <div class="flex items-center">
                {{ order.saUniqueId }}
                <sa-lohi-preload-status [order]="order"></sa-lohi-preload-status>
                <img
                  *ngIf="order.boxPickup"
                  class="w-4"
                  src="/assets/icons/box_move.svg"
                  alt="box move"
                  matTooltip="Box Move: {{ order.boxPickup.siteName }}. Out of Route Miles: {{
                    order.boxPickupOORMiles.oorMiles
                  }} miles"
                />
              </div>
              <div>Seq. #: {{ order.loadNumber }}</div>
            </div>
            <ng-container *saFeatureFlag="'onOrderTooLong'; else onlyUpdatedToWells">
              <div
                class="timestamp unreachable"
                *ngIf="order.dispatchTimestamp | onOrderTooLong; else updatedAtToWells"
              >
                On Load for {{ order.dispatchTimestamp | ago: false }}
                <br />
                <span class="preload" *ngIf="order.isPreLoad">PreLoad</span>
              </div>
              <ng-template #updatedAtToWells>
                <ng-container *ngIf="order.orderStatus === 'dispatched'; else acceptedOrders">
                  <div
                    class="timestamp timestamp-updated"
                    [ngClass]="{ unreachable: helperService.checkIfOnOrderTooLong(order.dispatchTimestamp) }"
                  >
                    <span>Sent</span>
                    {{ helperService.calculateReceivingTime(order.dispatchTimestamp) }} ago
                  </div>
                </ng-container>
                <ng-template #acceptedOrders>
                  <div
                    class="timestamp timestamp-updated"
                    [ngClass]="{ unreachable: order.user?.userStatus?.type === 'Unreachable' }"
                  >
                    <span>Updated</span>
                    {{ helperService.calculateReceivingTime(order.user?.lastTimeSeen) }} ago
                    <br />
                    <span class="preload" *ngIf="order.isPreLoad">PreLoad</span>
                  </div>
                </ng-template>
              </ng-template>
            </ng-container>
            <ng-template #onlyUpdatedToWells>
              <ng-container *ngIf="order.orderStatus === 'dispatched'; else acceptedWellOrders">
                <div
                  class="timestamp timestamp-updated"
                  [ngClass]="{ unreachable: helperService.checkIfOnOrderTooLong(order.dispatchTimestamp) }"
                >
                  <span>Sent</span>
                  {{ helperService.calculateReceivingTime(order.dispatchTimestamp) }} ago
                </div>
              </ng-container>
              <ng-template #acceptedWellOrders>
                <div
                  class="timestamp timestamp-updated"
                  [ngClass]="{ unreachable: order.user?.userStatus?.type === 'Unreachable' }"
                >
                  <span>Updated</span>
                  {{ helperService.calculateReceivingTime(order.user?.lastTimeSeen) }} ago
                </div>
              </ng-template>
            </ng-template>
          </div>

          <div class="order-content-wrap">
            <div class="order-body">
              <div class="driver-details">
                {{ order?.user?.name }}<span *ngIf="order.truck">,</span> {{ order?.truck?.name }}
                <span *ngIf="order.trailer">,</span>{{ order?.trailer?.name }}
              </div>
              <div class="desc" *ngIf="order.subcarrierName">
                {{ order.subcarrierName }}
              </div>
              <div *ngIf="byDestinationView$ | async" class="desc">{{ order.mesh.type }} Mesh</div>
              <div class="desc">
                {{ order.vendor.name }}
                <span *ngIf="order.classicSubcontractorName">({{ order.classicSubcontractorName }}) </span> →
                {{ order.mine.site.name }}
                <div *saFeatureFlag="'orderTrailerType'">
                  <div *ngIf="order.trailerType">Trailer Type: {{ order.trailerType?.trailerTypeDisplayName }}</div>
                </div>
              </div>
            </div>
            <div class="detail-wrap">
              <ng-container
                *ngIf="order.user?.userStatus?.type === 'Online' || order.user?.userStatus?.type === 'Unreachable'"
              >
                <div class="timestamp">
                  <span *ngIf="isEtaArrived(order)">ARRIVED</span>
                  <span *ngIf="isEtaStaging(order)">STAGING</span>
                  <ng-container *ngIf="isEtaNone(order)">
                    <span *ngIf="order.eta; else noEta">{{ order.eta | eta }}</span>
                    <ng-template #noEta>
                      <span>--</span>
                    </ng-template>
                  </ng-container>
                </div>
                <div class="driver-status">
                  <ng-container *ngIf="!isEtaArrived(order) && !isEtaStaging(order); else etaArrivedOrStaging">
                    <span *ngIf="!order.loaded">PICKUP</span>
                    <span *ngIf="order.loaded">DROPOFF</span>
                  </ng-container>
                  <ng-template #etaArrivedOrStaging>
                    <ng-container *ngIf="isEtaArrived(order)">
                      <div *ngIf="order.loaded; else unloaded">
                        <div>
                          {{ order.fracSiteVisit?.wellEntryTimestamp || order.fracSiteVisit?.startTimestamp | ago }}
                        </div>
                        <div>
                          DROPOFF
                        </div>
                      </div>
                      <ng-template #unloaded>
                        <div>
                          <div>{{ order.mineSiteVisit?.startTimestamp | ago }}</div>
                          <div>
                            PICKUP
                          </div>
                        </div>
                      </ng-template>
                    </ng-container>
                    <ng-container *ngIf="isEtaStaging(order)">
                      <span>{{ order.fracSiteVisit?.startTimestamp | ago }}</span>
                    </ng-container>
                  </ng-template>
                </div>
              </ng-container>
              <div class="action-needed" *ngIf="isUnreachable(order.user?.userStatus?.type) && !order.isPreLoad">
                Action Needed
              </div>
              <ng-container *saAllowedAccountRoles="[9]">
                <ng-container *saFeatureFlag="'orderVerificationBySandCoordinator'">
                  <div *ngIf="order.verificationAction === 'verify'" class="flex flex-row items-baseline pt-1 verified">
                    <i class="material-icons">check_circle</i><span class="italic">Verified</span>
                  </div>
                  <div *ngIf="order.verificationAction === 'reject'" class="flex flex-row items-baseline pt-1 rejected">
                    <i class="material-icons">cancel</i><span class="italic">Rejected</span>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>
          <div class="reroute-wrap" *ngIf="order.reroutedFrom">
            <img class="reroute-img low-height" src="../../../../assets/icons/RerouteFrom.png" alt="reroutedFrom" />
            <h3>
              FROM
              <span *ngIf="order.mine.site.name !== order.reroutedFrom.mineName">{{
                order.reroutedFrom.mineName
              }}</span>
              <span
                *ngIf="
                  order.reroutedFrom.fracId !== order.fracId && order.mine.site.name === order.reroutedFrom.mineName
                "
                >{{ order.reroutedFrom.fracName }}</span
              >
            </h3>
          </div>
          <div class="reroute-wrap" *ngIf="order.reroutedTo && !order.reroutedFrom">
            <img class="reroute-img" src="../../../../assets/icons/RerouteTo.png" alt="reroutedTo" />
            <h3>
              To
              <span *ngIf="order.mine.site.name !== order.reroutedTo.mineName">{{ order.reroutedTo.mineName }}</span>
              <span
                *ngIf="order.fracId !== order.reroutedTo.fracId && order.mine.site.name === order.reroutedTo.mineName"
                >{{ order.reroutedTo.fracName }}</span
              >
            </h3>
          </div>
          <div class="alert-wrap" *ngFor="let reason of checkBolMissingDetails(order); trackBy: trackByFnReason">
            <div>
              <img src="/assets/icons/alarm-24.svg" alt="Alert" />
            </div>
            {{ reason }}
          </div>
          <div class="alert-wrap" *ngIf="order.user?.userStatus?.isException">
            <div><img src="../../../../assets/icons/alarm-24.svg" alt="Alert" /></div>
            <span>{{ order.user?.userStatus?.exceptionTitle }}</span>
          </div>
        </a>
      </div>
    </ng-container>
  </mat-selection-list>
  <div class="flex p-1 items-center justify-between" *ngIf="selectedOrderIds.selectedOptions.selected.length">
    <div>{{ selectedOrderIds.selectedOptions.selected.length | i18nPlural: loadPluralMapping }} Selected</div>
    <div>
      <button
        mat-stroked-button
        color="warn"
        (click)="cancelOrders()"
        saAutomatedSelector="lmo_orders_pending__cancel_selected_button"
      >
        Cancel (Unloaded Only)
      </button>
    </div>
  </div>
</div>
